// @ts-nocheck
import { all, call, put, takeLatest } from "redux-saga/effects";

import { Axios } from "../../api/axios";
import { getSimplifiedError } from "../../utils/error";
import {
  CALCULATOR_DETAILS_SAVE_REQUEST,
  CALCULATOR_DETAILS_SAVE_SUCCESS,
  CALCULATOR_DETAILS_SAVE_ERROR,
  GET_CALCULATOR_REQUEST,
  GET_CALCULATOR_SUCCESS,
  GET_CALCULATOR_ERROR,
  DELETE_CALCULATOR_REQUEST,
  DELETE_CALCULATOR_SUCCESS,
  DELETE_CALCULATOR_ERROR,
  EDIT_CALCULATOR_REQUEST,
  EDIT_CALCULATOR_SUCCESS,
  EDIT_CALCULATOR_ERROR,
} from "../reducers/CalculatorReducer";
import { toast } from "react-toastify";

async function addCalc(payload) {
  return await Axios.post("/calculator/add_calc/", payload);
}
function* handleAddCalc({ payload }) {
  try {
    const response = yield call(addCalc, payload);
    if (response.success) {
      yield put({
        type: CALCULATOR_DETAILS_SAVE_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    toast(getSimplifiedError(error), {
      type: "error",
      position: "bottom-left",
      toastId: "api-error-add-calc",
    });
    yield put({
      type: CALCULATOR_DETAILS_SAVE_ERROR,
      error: getSimplifiedError(error),
    });
  }
}

async function getCalc(payload) {
  return await Axios.get("/calculator/get_calc/", { params: { ...payload } });
}
function* handleGetCalc({ payload }) {
  try {
    const response = yield call(getCalc, payload);
    if (response) {
      yield put({
        type: GET_CALCULATOR_SUCCESS,
        payload: response.calculators,
      });
    }
  } catch (error) {
    toast(getSimplifiedError(error), {
      type: "error",
      position: "bottom-left",
      toastId: "handle_get_calc",
    });
    yield put({
      type: GET_CALCULATOR_ERROR,
      error: getSimplifiedError(error),
    });
  }
}

async function editCalc(payload) {
  return await Axios.post("/calculator/update_calc/", { ...payload });
}
function* handleEditCalc({ payload }) {
  try {
    const response = yield call(editCalc, payload);
    if (response) {
      yield put({
        type: EDIT_CALCULATOR_SUCCESS,
        payload: response.calculators,
      });
    }
  } catch (error) {
    toast(getSimplifiedError(error), {
      type: "error",
      position: "bottom-left",
      toastId: "edit-calc",
    });
    yield put({
      type: EDIT_CALCULATOR_ERROR,
      error: getSimplifiedError(error),
    });
  }
}

async function deleteCalc(payload) {
  return await Axios.post("/calculator/remove_calc/", {
    ...payload,
  });
}
function* handleDeleteCalc({ payload }) {
  try {
    const response = yield call(deleteCalc, payload);
    if (response.success) {
      yield put({
        type: DELETE_CALCULATOR_SUCCESS,
        payload: response.calculators,
      });
    }
  } catch (error) {
    toast(getSimplifiedError(error), {
      type: "error",
      position: "bottom-left",
      toastId: "delete-calc",
    });
    yield put({
      type: DELETE_CALCULATOR_ERROR,
      error: getSimplifiedError(error),
    });
  }
}

export default all([
  takeLatest(CALCULATOR_DETAILS_SAVE_REQUEST, handleAddCalc),
  takeLatest(EDIT_CALCULATOR_REQUEST, handleEditCalc),
  takeLatest(GET_CALCULATOR_REQUEST, handleGetCalc),
  takeLatest(DELETE_CALCULATOR_REQUEST, handleDeleteCalc),
]);
